import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConstUserGroupEnum } from "../../../../models/ConstUserGroupEnum";
import { ObjectTypeNamesEnum } from "../../../../models/ObjectTypeEnum";
import { getCoursesData } from "../../../../store/discipline-action";
import { DeleteIcon, DuplicateIcon } from "../../../lms-shared/UI/ActionsIcons";
import EyeIcon from "../../../UI/EyeIcon";
import classes from "./Message.module.css";
import { selectDisciplinesCurrentYear } from "../../../../store/discipline-slice";

const Message = ({ contents, targetObjectType, targetObjectId, sentDate, expireDate, messageType, editMessage, deleteMessage, duplicateMessage }) => {
    const { lang, texts } = useSelector(state => state.translate);
    const disciplines = useSelector(state => selectDisciplinesCurrentYear(state));
    const dispatch = useDispatch();
    const applicationId = useSelector(state => state.application.applicationId);

    useEffect(() => {
        if (!disciplines && applicationId)
            dispatch(getCoursesData());
    }, [applicationId])

    const getTarget = () => {
        switch (targetObjectType) {
            case ObjectTypeNamesEnum.ConstUserGroup:
                switch (targetObjectId) {
                    case ConstUserGroupEnum.All:
                        return texts.all;
                    case ConstUserGroupEnum.Student:
                        return texts.students;
                    case ConstUserGroupEnum.Teacher:
                        return texts.teachers;
                }
            case ObjectTypeNamesEnum.Course:
                return `${texts.students} ${disciplines.find(c => c.id === targetObjectId)?.name}`

        }
    }
    return <div className={classes.Message} onClick={editMessage}>
        <EyeIcon width={"22px"} status={expireDate && new Date() >= expireDate}></EyeIcon>
        <div className={classes.Dates}>
            <div className={classes.ExpireDate}>{expireDate && expireDate.getTime() !== new Date(null).getTime() && moment(expireDate).format("YY.MM.DD")}</div>
            <div className={classes.SentDate}> {moment(sentDate).format("YY.MM.DD")}</div>
        </div>
        <div className={classes.Target}>{disciplines && getTarget()}</div>
        <div className={classes.Icon} style={{ backgroundImage: `url(${messageType && messageType.icon})` }}></div>
        <div className={classes.Content}>{contents?.[lang]?.text}</div>
        <DuplicateIcon onClick={duplicateMessage} width={"21px"}></DuplicateIcon>
        <DeleteIcon onClick={deleteMessage} width={"21px"}></DeleteIcon>
    </div>
}

export default Message;